import EntityContentItemForm from './EntityContentItemForm';

export default EntityContentItemForm;
